import { type UtmParams } from "@/utils/getUtmParams";

const UTM_STORAGE_KEY = "utm_params";

/**
 * Reads persisted UTM parameters from localStorage.
 * Returns an empty object when called on the server or when stored data is invalid.
 */
export const getStoredUtmParams = (): UtmParams => {
  if (typeof window === "undefined") {
    return {};
  }

  try {
    return JSON.parse(localStorage.getItem(UTM_STORAGE_KEY) || "{}") as UtmParams;
  } catch {
    return {};
  }
};

/**
 * Persists UTM parameters when at least one parameter has a value.
 */
export const saveUtmParams = (params: UtmParams) => {
  if (typeof window === "undefined") {
    return;
  }

  if (!Object.values(params).some(Boolean)) {
    return;
  }

  localStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(params));
};

/**
 * Merges UTM parameters detected in the current URL with persisted values,
 * preferring current URL values when available.
 */
export const resolveUtmParams = (currentParams: UtmParams): UtmParams => {
  const storedParams = getStoredUtmParams();

  return {
    utm_source: currentParams.utm_source || storedParams.utm_source || undefined,
    utm_medium: currentParams.utm_medium || storedParams.utm_medium || undefined,
    utm_campaign: currentParams.utm_campaign || storedParams.utm_campaign || undefined,
    utm_id: currentParams.utm_id || storedParams.utm_id || undefined,
  };
};
